import GroupModel from "models/group.model";
import ClientModel from "models/client.model";

export const getGroupLabel = (group: GroupModel) =>
  `${group.code} - ${group.name}`;

export const getClientLabel = (client: ClientModel) =>
  `${client.code} - ${client.name}`;
